import { useGetMetadata } from "../api/settings/settings.api";

export const useMetadata = () => {
  const { data: metadata, isLoading } = useGetMetadata();

  const queryLimitReached =
    metadata?.hendrenTier === "FREE"
      ? metadata.rateLimit.monthlyQueryCount >= metadata.rateLimit.monthlyQueryLimit
      : false;

  const monthlyLimit = metadata?.rateLimit.monthlyQueryLimit ?? 0;
  const monthlyCount = metadata?.rateLimit.monthlyQueryCount ?? 0;
  const remainingQueries = Math.max(0, monthlyLimit - monthlyCount);

  return {
    hendrenTier: metadata?.hendrenTier ?? "FREE",
    queryLimitReached,
    isLoading,
    remainingQueries,
    availableModels: metadata?.availableModels ?? [],
    ...metadata?.rateLimit,
  };
};
